/** Human-friendly duration from seconds (s → m → h → d → mo). */
export const formatDuration = (seconds) => {
  const total = Math.max(0, Math.floor(Number(seconds) || 0));
  if (total < 60) return `${total}s`;

  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  const remMin = minutes % 60;
  if (hours < 24) {
    return remMin > 0 ? `${hours}h ${remMin}m` : `${hours}h`;
  }

  const days = Math.floor(hours / 24);
  const remHours = hours % 24;
  if (days < 60) {
    return remHours > 0 ? `${days}d ${remHours}h` : `${days}d`;
  }

  const months = Math.floor(days / 30);
  const remDays = days % 30;
  if (months < 24) {
    return remDays > 0 ? `${months}mo ${remDays}d` : `${months}mo`;
  }

  const years = Math.floor(months / 12);
  const remMonths = months % 12;
  return remMonths > 0 ? `${years}y ${remMonths}mo` : `${years}y`;
};

export const formatDurationFromHours = (hours) =>
  formatDuration(Math.floor((Number(hours) || 0) * 3600));

export const formatDurationFromMinutes = (minutes) =>
  formatDuration(Math.floor((Number(minutes) || 0) * 60));

/** Scale bytes → KB / MB / GB / TB / PB. */
export const formatBytes = (bytes) => {
  const value = Math.max(0, Number(bytes) || 0);
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  if (value < 1024) return `${Math.round(value)} B`;

  let unit = 0;
  let n = value;
  while (n >= 1024 && unit < units.length - 1) {
    n /= 1024;
    unit += 1;
  }

  const digits = n >= 100 || unit <= 1 ? 0 : n >= 10 ? 1 : 2;
  return `${n.toFixed(digits)} ${units[unit]}`;
};

export const formatBytesFromMB = (mb) => formatBytes((Number(mb) || 0) * 1024 * 1024);

export const formatBytesFromGB = (gb) => formatBytes((Number(gb) || 0) * 1024 ** 3);
